import React from 'react'

export const CostListRepricerAdditionalInfo = () => {
  return (
    <div className="flex flex-wrap gap-6 text-white text-sm mt-10 items-center justify-center px-6 lg:px-0">
      <div className="flex items-center gap-5 flex-1 max-w-[50%] min-w-[300px] rounded-xl px-6 py-5 bg-[#252B30] bg-[linear-gradient(90deg,_rgba(91,86,74,0.80)_0%,_rgba(37,43,48,0)_58%)]">
        <span className="text-[40px]">📦</span>
        Учитываются все товары в&nbsp;наличии,
        <br />
        даже если для&nbsp;части из них репрайсер не&nbsp;настроен
      </div>
      <div className="flex items-center gap-5 flex-1 max-w-[50%] min-w-[300px] rounded-xl px-6 py-5 bg-[#252B30] bg-[linear-gradient(30deg,_rgba(119,103,43,0.78)_0%,_rgba(37,43,48,0)_41%)]">
        <span className="text-[40px]">🔑</span>
        Количество API-ключей и количество кабинетов не&nbsp;влияет
        на&nbsp;стоимость тарифа
      </div>
    </div>
  )
}
